import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

import PaymentForm from 'shared/components/PaymentForm';

class StripeForm extends React.Component {
  constructor(props) {
    super(props);
    this.stripePromise = loadStripe(this.props.stripeKey);
  }

  render() {
    return (
      <Elements stripe={this.stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => {
            return (
              <PaymentForm
                elements={elements}
                stripe={stripe}
                button={this.props.button}
                processingText={this.props.processingText}
                callback={this.props.callback}
                email={this.props.email}
                name={this.props.name}
                accountId={this.props.accountId}
                storyId={this.props.storyId}
                kioskToken={this.props.kioskToken}
                errorStyle={this.props.errorStyle}
                purchaseRequestId={this.props.purchaseRequestId}
                freeMode={this.props.freeMode}
                description={this.props.description}
                discountCode={this.props.discountCode}
                requiredName={this.props.requiredName}
                confirmCallback={this.props.confirmCallback}
              />
            );
          }}
        </ElementsConsumer>
      </Elements>
    );
  }
}

export default StripeForm;
